var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../api/axios";
import { PasswordSetText } from "./PasswordSet-types";
export const resetPassword = (payload, onSuccess, onError) => {
    var _a;
    const token = ((_a = document.getElementsByName("__RequestVerificationToken")) === null || _a === void 0 ? void 0 : _a[0]).value;
    return axiosPrivate
        .post("/PasswordSet", payload, { headers: { RequestVerificationToken: token } })
        .then(onSuccess)
        .catch(onError);
};
export const handleFormSubmit = (authCode, setLoading, setError, toast, navigate) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    const payload = {
        AuthCode: authCode !== null && authCode !== void 0 ? authCode : "",
        Password: data.password,
        ConfirmPassword: data.confirmPassword,
    };
    yield resetPassword(payload, onSuccess(toast, setLoading, setError, navigate), onError(toast, setLoading));
});
export const onSuccess = (toast, setLoading, setError, navigate) => (res) => {
    var _a, _b, _c, _d, _e;
    setLoading(false);
    if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.redirect) {
        navigate(res.data.redirect);
        return;
    }
    if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.success)) {
        if ((_d = (_c = res.data) === null || _c === void 0 ? void 0 : _c.modelErrors) === null || _d === void 0 ? void 0 : _d.Password) {
            setError("password", { message: res.data.modelErrors.Password.join("|") });
        }
        else {
            toast.push((_e = res.data.message) !== null && _e !== void 0 ? _e : PasswordSetText.GENERIC_ERROR, { variant: "error" });
        }
    }
};
export const onError = (toast, setLoading) => (err) => {
    var _a;
    setLoading(false);
    toast.push((_a = err.response.data.message) !== null && _a !== void 0 ? _a : PasswordSetText.GENERIC_ERROR, { variant: "error" });
};
